import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.js';
import './styles/globals.css';
// The shared premium kit — shimmer skeletons, pressed/hover response, and the
// branded `:focus-visible` ring. This app was the only one of the five that
// never loaded it (measured 2026-08-24), so it had NO branded keyboard focus
// anywhere and its loading states were static grey blocks. Imported after
// globals.css so app tokens win where they disagree, matching dashboard.
import '@kilat/ui/premium-motion.css';

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('#root not found');

createRoot(rootEl).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
